import React, { useEffect } from 'react'
import './customModal.css';
export const CustomModal = ({ title = null, backdrop = 'static', centered = false, showModal, setShowModal, size = 'lg', children, fullscreen = false, backgroundColor = '#FFFF', style = {}, }) => {

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (e.target.classList.contains('modal')) {
        setShowModal();
      }
    };

    if (showModal) {
      window.addEventListener('click', handleOutsideClick);
    } else {
      window.removeEventListener('click', handleOutsideClick);
    }

    return () => {
      window.removeEventListener('click', handleOutsideClick);
    };
    // eslint-disable-next-line
  }, [showModal]);

  return (
    <div>
      {showModal && (
        <div
          className="modal show fade"
          tabIndex="-1"
          style={{ display: 'block' }}
          data-bs-backdrop={backdrop}
        >
          <div
            className={`modal-dialog modal-${size} ${fullscreen ? ('modal-fullscreen') : ''} ${centered ? ('modal-dialog-centered') : ''}`}
          >
            <div
              className="modal-content"
              style={{ backgroundColor }}
            >

              {title && (
                <div className="modal-header">
                  <h5 className="modal-title">
                    {title}
                  </h5>
                  <button
                    type="button"
                    className="btn"
                    onClick={setShowModal}
                  >
                    <i className="fa-solid fa-xmark"></i>
                  </button>
                </div>
              )}

              <div
                className="modal-body"
                style={style}
              >
                {children}
              </div>

            </div>
          </div>
        </div>
      )}
      {showModal && (
        <div className="modal-backdrop show"></div>
      )}
    </div>
  );
}